let React = require('react');
let _ = require('lodash');
let Preview = require('./preview_component');
let Header = require('./walk_through/header');
let Buttons = require('./walk_through/buttons');
let PageToggler = require('./page_toggler_component');
const ErrorPage = require('better_error_pages/app');

// Questions
let Welcome = require('./walk_through/questions/welcome');                  // Step 0
let HaveStatusPage = require('./walk_through/questions/have_status_page');  // Step 1
let UrlsForm = require('./walk_through/questions/urls_form');               // Step 2
let ChooseTemplate = require('./walk_through/questions/choose_template');   // Step 3
let Personalize = require('./walk_through/questions/personalize');          // Step 4
let Download = require('./walk_through/questions/download');                // Step 5
let ThankYou = require('./walk_through/questions/thank_you');               // Step 6

class GetStarted extends React.Component {

  constructor (props) {
    let newProps = Object.assign({}, props);
    newProps = props.bep;
    newProps.reddit_link = props.reddit_link || '';
    newProps.hacker_news_link = props.hacker_news_link || '';
    newProps.product_hunt_link = props.product_hunt_link || '';
    newProps.thumbnails = props.thumbnails;
    newProps.defaults = props.defaults;

    super(props);

    let state = props.bep;
    state.loggedIn = window.loggedIn;
    state.page_type = '503';
    state.subscribe_to_news_letter = true;
    state.step = 0;
    state.downloadRequestSent = false;

    this.state = state;
    this.cache = {};

    this.pushStateToServer = _.debounce(() => {
      // If there's nothing to update, don't push an update!
      if (Object.keys(this.cache).length === 0) return;
      $.ajax({
        url : '/customize/' + this.props.bep.id,
        type : 'PUT',
        data : {bep : this.cache}
      }).always(function () {
        this.cache = {};
      }.bind(this));
    }, 200);

    this.getCodeFromUrl = _.debounce((value) => {
      $.ajax({
        type : "GET",
        url : '/page_code?q=' + value
      }).success(function (response) {
        this.update('page_code', response.page.id);
      }.bind(this)).fail(function () {
        ErrorPage.prototype.handleStatusFetchFail();
        this.triggerAlert('The Statuspage URL or code you entered was invalid.  Please try again.', 'error');
        this.setState({page_code : null});
      }.bind(this));
    }, 1000);
  }

  componentDidUpdate () {
    this.setWalkthroughHeight();
  }

  componentDidMount () {
    this.setWalkthroughHeight();
    $(window).on('resize', this.setWalkthroughHeight);

    this.preloadImages();
  }

  preloadImages () {
    // preloads template images to prevent need to resize after the step is shown
    let img1 = new Image(),
       img2 = new Image(),
       img3 = new Image();

    img1.src = this.props.thumbnails.plain;
    img2.src = this.props.thumbnails.background;
    img3.src = this.props.thumbnails.sign;
  }

  setWalkthroughHeight () {
    let $elem = $('.step-container'),
       $wkHeader = $('.walkthrough-header'),
       $wkButtons = $('.walkthrough-buttons'),
       difference = ($(window).innerHeight() - $elem.outerHeight() - $wkHeader.outerHeight() - $wkButtons.outerHeight()) / 2;

    $elem.css('max-height', $(window).innerHeight() - $wkHeader.outerHeight() - $wkButtons.outerHeight());

    if (difference > 0) {
      $elem.css('margin-top', difference).css('margin-bottom', difference);
    }    else {
      $elem.css('margin-top', 0).css('margin-bottom', 0);
    }
  }

  resetDefaultValues (template) {
    var defaults = this.props.defaults[template];

    for (var prop in defaults) {
      if (prop == 'template') {
        return;
      }
      
        this.update(prop, defaults[prop]);
      
    }
  }

  update (key, value) {
    let newState = {};
    newState[key] = value;

    if (key === 'has_status_page') {
      newState.page_code = null;
    }

    // We need to cache our updates so the debounced server update posts everything
    this.cache[key] = value;

    this.setState(newState, (state) => {

      if (key === 'template') this.resetDefaultValues(value);

      if ((key === 'status_page_url' && this.state.has_status_page === 'customer' && !!this.state.status_page_url)) {
        this.getCodeFromUrl(value);
      }

      this.pushStateToServer();
    });
  }

  renderQuestion () {
    switch (this.state.step) {
      case 0:
        return <Welcome />;
      case 1:
        return <HaveStatusPage {...this.state} onChange={this.update.bind(this)}  />;
      case 2:
        return <UrlsForm {...this.state} onChange={this.update.bind(this)}  />;
      case 3:
        return <ChooseTemplate {...this.state} onChange={this.update.bind(this)}  />;
      case 4:
        return (<Personalize {...this.state} onChange={this.update.bind(this)}
                                            resetDefaultValues={this.resetDefaultValues.bind(this)}/>);
      case 5:
        return <Download {...this.state} onChange={this.update.bind(this)}  />;
      case 6:
        return <ThankYou {...this.state} onChange={this.update.bind(this)}  />;
      default:
        return <Welcome {...this.state} onChange={this.update.bind(this)}  />;
    }
  }

  triggerAlert (text, type) {
    HRB.utils.notify(text, { cssClass: type });
  }

  canContinue () {
    if (this.state.step === 5 && this.state.send_to_email_address && this.state.send_to_email_address.indexOf('@') > 1) {
      return true;
    } else if (this.state.step === 2 && this.state.has_status_page === 'customer' && !this.state.page_code) {
      return false;
    } 
      return this.state.step <= 4 && this.state !== 6;
    
  }

  canGoBack () {
    return this.state.step !== 0;
  }

  continue () {
    if (this.canContinue()) {
      if (this.state.step === 1 && this.state.has_status_page === 'customer' && !!this.state.status_page_url && !this.state.page_code) {
        // If customer is selected, and a status page url is defined and page code is not, pull the page code
        this.getCodeFromUrl(this.state.status_page_url);
      }

      if (this.state.step === 5 && this.state.downloadRequestSent === false) {
        this.submitDownloadRequest();
      }
      this.setState({ step: this.state.step + 1 });
    }
  }

  back () {
    if (this.canGoBack()) {
      this.setState({ step: this.state.step - 1 });
    }
  }

  continueText () {
    if (this.state.step === 6) return null;
    return this.state.step === 5 ? 'Get Error Pages' : 'Continue';
  }

  backText () {
    return this.state.step <= 1 ? null : 'Back';
  }

  submitDownloadRequest () {
    $.ajax({
      type: 'POST',
      url: '/request_download',
      data: {
        download_request: {
          send_to_email_address: this.state.send_to_email_address,
          bep_id: this.props.bep.id,
          subscribe_to_news_letter: this.state.subscribe_to_news_letter,
        },
      },
      success: function (response) {
      },
    });
    this.state.downloadRequestSent = true;
  }

  setPageType (type) {
    this.update('page_type', type);
  }

  preview () {
    if (this.state.step > 2 && this.state.step !== 6) {
      return (
        <div className="preview-container">
          <PageToggler {...this.state} onChange={this.setPageType.bind(this)}/>
          <Preview {...this.state} />
        </div>
      )
    } 
      var height = $(window).outerHeight() + 'px';
      return (
        <div className="preview-container" style={{display: 'table'}}>
          <div
            style={{height: height, width: '100%', background: '#ddd', textAlign: 'center', display: 'table-cell', verticalAlign: 'middle'}}>
            <img src="/logo?type=poke&poke_color=rgba(0, 0, 0, 0.03)" style={{width: '25%'}}/>
          </div>
        </div>
      )
    
  }

  render () {
    return (
      <div>
        <div className="walkthrough-container">
          <Header logoUrl={this.props.logo_url} />

          {this.renderQuestion()}

          <Buttons
             continue={this.continue.bind(this)}
            back={this.back.bind(this)}
            continueText={this.continueText()}
            backText={this.backText()}
          />

        </div>
        {this.preview()}
      </div>
    );
  }

}

module.exports = GetStarted;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/better_error_pages/get_started.jsx